import "moment-timezone";
import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { RootState } from "../redux/store";

//const apiLink =
//	window.location.hostname === "192.168.1.131"
//		? "http://192.168.1.130:7000/api/v1/"
//		: "http://ttdcepf.com:7000/api/v1/";

//const apiLink = "http://192.168.1.130:7000/api/v1/";

const apiLink = "https://ttdcepf.com/app/api/v1/";

export const btBaseQuery = fetchBaseQuery({
	baseUrl: apiLink,
	prepareHeaders: (headers, { getState }) => {
		const token = (getState() as RootState).gdata.token;
		if (token) {
			headers.set("auth", `${token}`);
		}
		return headers;
	},
});
export const storeToken = (jwtToken: string) => {
	try {
		localStorage.setItem("token", jwtToken);
	} catch (error) {
		// Error saving data
	}
};

export const retrieveToken = () => {
	try {
		const value = localStorage.getItem("token");
		if (value !== null) {
			return value;
		}
	} catch (error) {
		return error;
	}
};

export const storeSetting = (name: string, value: string) => {
	try {
		localStorage.setItem(name, value);
	} catch (error) {
		// Error saving data
	}
};

export const retrieveSetting = (name: string) => {
	try {
		const value = localStorage.getItem(name);
		if (value !== null) {
			return value;
		}
	} catch (error) {
		return error;
	}
};

export const removeSetting = (name: string) => {
	try {
		localStorage.removeItem(name);
		return true;
	} catch (error) {
		return error;
	}
};
